import React, { PropsWithChildren } from 'react';

import {
  useAddBusinessPlan,
  useEditorAndDashboardUpdateFeature,
} from '@editor/global/growthbookUtils';
import { isMobileOperatingSystem as getIsMobileOperatingSystem } from '@repo/detection';
import { Modal } from '@repo/ui/deprecated/Modal';
import { Dialog } from '@repo/ui-kit/components/core/Dialog';

type Props = {
  isOpen: boolean;
  onClose: (() => void) | undefined;
};

/**
 * This component mounts the upgrade flow modal.
 */
const ModalContainer: React.FC<PropsWithChildren<Props>> = ({
  children,
  isOpen,
  onClose,
}) => {
  const isNewDesignEnabled = useEditorAndDashboardUpdateFeature();
  const businessPlanIsEnabled = useAddBusinessPlan();

  const desktopModalHeight = '720px';
  const desktopModalWidth = businessPlanIsEnabled ? '988px' : '940px';
  const isMobileOperatingSystem = getIsMobileOperatingSystem();

  if (isNewDesignEnabled) {
    return (
      <Dialog.Root
        modal
        open={isOpen}
        onOpenChange={(open) => {
          if (!open) {
            onClose?.();
          }
        }}
      >
        <Dialog.Content
          global
          showCloseButton
          height={!isMobileOperatingSystem ? desktopModalHeight : undefined}
          title="Upgrade Modal"
          width={!isMobileOperatingSystem ? desktopModalWidth : undefined}
        >
          {children}
        </Dialog.Content>
      </Dialog.Root>
    );
  }

  return (
    <Modal
      externalCloseButton={!isMobileOperatingSystem}
      height={!isMobileOperatingSystem ? desktopModalHeight : undefined}
      isOpen={isOpen}
      theme={{ padding: '0px 10px' }}
      width={!isMobileOperatingSystem ? desktopModalWidth : undefined}
      onClose={onClose}
    >
      {children}
    </Modal>
  );
};

export default ModalContainer;
